<a
    href="javascript:void(0)"
    #tooltip="matTooltip"
    matTooltip="{{ 'SETTING_PAGE.IDMS_SETTINGS.DOWNLOAD_SPREADSHEET' | transloco }}"
    [matTooltipPosition]="tooltip_position"
    class="me-5"
    mat-button
    [matMenuTriggerFor]="activityMenu"
>
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <rect x="0" y="0" width="24" height="24" />
            <rect
                fill="#000000"
                opacity="0.3"
                transform="translate(12.000000, 7.000000) rotate(-180.000000) translate(-12.000000, -7.000000) "
                x="11"
                y="1"
                width="2"
                height="12"
                rx="1"
            />
            <path
                d="M17,8 C16.4477153,8 16,7.55228475 16,7 C16,6.44771525 16.4477153,6 17,6 L18,6 C20.209139,6 22,7.790861 22,10 L22,18 C22,20.209139 20.209139,22 18,22 L6,22 C3.790861,22 2,20.209139 2,18 L2,9.99305689 C2,7.7839179 3.790861,5.99305689 6,5.99305689 L7.00000482,5.99305689 C7.55228957,5.99305689 8.00000482,6.44077214 8.00000482,6.99305689 C8.00000482,7.54534164 7.55228957,7.99305689 7.00000482,7.99305689 L6,7.99305689 C4.8954305,7.99305689 4,8.88848739 4,9.99305689 L4,18 C4,19.1045695 4.8954305,20 6,20 L18,20 C19.1045695,20 20,19.1045695 20,18 L20,10 C20,8.8954305 19.1045695,8 18,8 L17,8 Z"
                fill="#000000"
                fill-rule="nonzero"
                opacity="0.3"
            />
            <path
                d="M14.2928932,10.2928932 C14.6834175,9.90236893 15.3165825,9.90236893 15.7071068,10.2928932 C16.0976311,10.6834175 16.0976311,11.3165825 15.7071068,11.7071068 L12.7071068,14.7071068 C12.3165825,15.0976311 11.6834175,15.0976311 11.2928932,14.7071068 L8.29289322,11.7071068 C7.90236893,11.3165825 7.90236893,10.6834175 8.29289322,10.2928932 C8.68341751,9.90236893 9.31658249,9.90236893 9.70710678,10.2928932 L12,12.5857864 L14.2928932,10.2928932 Z"
                fill="#000000"
                fill-rule="nonzero"
            />
        </g>
    </svg>
</a>
<mat-menu #activityMenu="matMenu" class="menu-wrapper">
    <!-- Root Menu -->
    <ng-container *ngFor="let item of menuData">
        <button
            mat-menu-item
            [matMenuTriggerFor]="childMenu"
            *ngIf="item?.children?.length > 0"
            #menuTrigger="matMenuTrigger"
            (mouseenter)="onHover($event, null, selectionList, taggedItemselectionList)"
        >
            {{ item.name }}
        </button>
        <button mat-menu-item *ngIf="!item?.children?.length" (mouseenter)="onHover($event, null, selectionList, taggedItemselectionList)">
            {{ item.name }}
        </button>
        <mat-menu #childMenu="matMenu" (menuClosed)="onMenuClosed($event, item?.children, 'menuTrigger')" class="menu-wrapper">
            <!-- Sub Menu -->
            <ng-container *ngIf="IsCheckList(item)">
                <mat-selection-list
                    [(ngModel)]="selectedOptions"
                    [ngModelOptions]="{ standalone: true }"
                    (click)="$event.stopPropagation()"
                    #selectionList
                    (selectionChange)="onSelectionChange(selectionList)"
                    class="selection-list"
                >
                    <mat-list-option class="selection-option" *ngFor="let _item of item?.children" [value]="removeSpace(_item.name)" checkboxPosition="before">
                        {{ _item.name }}
                    </mat-list-option>
                </mat-selection-list>
                <a
                    href="javascript:void(0)"
                    #tooltip="matTooltip"
                    matTooltip="Download"
                    [matTooltipPosition]="tooltip_position"
                    class="me-5"
                    mat-button
                    style="float: right"
                    (click)="DownloadTemplate(removeSpace(item.name))"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        width="24px"
                        height="24px"
                        viewBox="0 0 24 24"
                        version="1.1"
                    >
                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <rect x="0" y="0" width="24" height="24" />
                            <rect
                                fill="#000000"
                                opacity="0.3"
                                transform="translate(12.000000, 7.000000) rotate(-180.000000) translate(-12.000000, -7.000000) "
                                x="11"
                                y="1"
                                width="2"
                                height="12"
                                rx="1"
                            />
                            <path
                                d="M17,8 C16.4477153,8 16,7.55228475 16,7 C16,6.44771525 16.4477153,6 17,6 L18,6 C20.209139,6 22,7.790861 22,10 L22,18 C22,20.209139 20.209139,22 18,22 L6,22 C3.790861,22 2,20.209139 2,18 L2,9.99305689 C2,7.7839179 3.790861,5.99305689 6,5.99305689 L7.00000482,5.99305689 C7.55228957,5.99305689 8.00000482,6.44077214 8.00000482,6.99305689 C8.00000482,7.54534164 7.55228957,7.99305689 7.00000482,7.99305689 L6,7.99305689 C4.8954305,7.99305689 4,8.88848739 4,9.99305689 L4,18 C4,19.1045695 4.8954305,20 6,20 L18,20 C19.1045695,20 20,19.1045695 20,18 L20,10 C20,8.8954305 19.1045695,8 18,8 L17,8 Z"
                                fill="#000000"
                                fill-rule="nonzero"
                                opacity="0.3"
                            />
                            <path
                                d="M14.2928932,10.2928932 C14.6834175,9.90236893 15.3165825,9.90236893 15.7071068,10.2928932 C16.0976311,10.6834175 16.0976311,11.3165825 15.7071068,11.7071068 L12.7071068,14.7071068 C12.3165825,15.0976311 11.6834175,15.0976311 11.2928932,14.7071068 L8.29289322,11.7071068 C7.90236893,11.3165825 7.90236893,10.6834175 8.29289322,10.2928932 C8.68341751,9.90236893 9.31658249,9.90236893 9.70710678,10.2928932 L12,12.5857864 L14.2928932,10.2928932 Z"
                                fill="#000000"
                                fill-rule="nonzero"
                            />
                        </g>
                    </svg>
                </a>
            </ng-container>
            <ng-container *ngIf="!IsCheckList(item)">
                <ng-container *ngFor="let child of item?.children">
                    <button
                        mat-menu-item
                        [matMenuTriggerFor]="subMenu"
                        *ngIf="child?.children?.length > 0"
                        #childTrigger="matMenuTrigger"
                        (mouseenter)="onHover($event, null, selectionList, taggedItemselectionList)"
                    >
                        {{ child.name }}
                    </button>
                    <button
                        mat-menu-item
                        *ngIf="!child?.children?.length"
                        (mouseenter)="onHover($event, null, selectionList, taggedItemselectionList)"
                        (click)="DownloadTemplate(removeSpace(item.name), child, child.id, item)"
                    >
                        {{ child.name }}
                    </button>

                    <mat-menu #subMenu="matMenu" (menuClosed)="onMenuClosed($event, child?.children, 'childTrigger')" class="menu-wrapper">
                        <!-- Sub Child Menu -->
                        <ng-container *ngFor="let subChild of child?.children">
                            <button
                                mat-menu-item
                                *ngIf="subChild?.children?.length > 0 && subChild.name == 'Joint'"
                                [matMenuTriggerFor]="lastMenu"
                                #subChildTrigger="matMenuTrigger"
                                (mouseenter)="onHover($event, subChild, selectionList, taggedItemselectionList)"
                            >
                                {{ subChild.name }}
                            </button>
                            <button
                                mat-menu-item
                                *ngIf="subChild?.children?.length > 0 && subChild.name != 'Joint'"
                                [matMenuTriggerFor]="lastMenu"
                                #subChildTrigger="matMenuTrigger"
                                (mouseenter)="onHover($event, null, selectionList, taggedItemselectionList)"
                            >
                                {{ subChild.name }}
                            </button>
                            <button
                                mat-menu-item
                                *ngIf="!subChild?.children?.length"
                                (mouseenter)="onHover($event, null, selectionList, taggedItemselectionList)"
                                (click)="DownloadTemplate(removeSpace(item.name), subChild, child?.id, child)"
                            >
                                {{ subChild.name }}
                            </button>
                            <mat-menu #lastMenu="matMenu" (menuClosed)="onMenuClosed($event, subChild?.children, 'subChildTrigger')" class="menu-wrapper">
                                <!-- last Menu -->
                                <ng-container *ngIf="IsCheckList(subChild)">
                                    <mat-selection-list
                                        [(ngModel)]="taggedItemselectedOptions"
                                        [ngModelOptions]="{ standalone: true }"
                                        (click)="$event.stopPropagation()"
                                        #taggedItemselectionList
                                        (selectionChange)="onTaggedItemSelectionChange(taggedItemselectionList)"
                                        class="selection-list"
                                    >
                                        <mat-list-option
                                            class="selection-option"
                                            *ngFor="let items of subChild?.children"
                                            [value]="removeSpace(items.name)"
                                            checkboxPosition="before"
                                        >
                                            {{ items.name }}
                                        </mat-list-option>
                                    </mat-selection-list>
                                    <a
                                        href="javascript:void(0)"
                                        #tooltip="matTooltip"
                                        matTooltip="Download{{ child?.name }}"
                                        [matTooltipPosition]="tooltip_position"
                                        class="me-5"
                                        mat-button
                                        style="float: right"
                                        (click)="DownloadTemplate(removeSpace(item.name), null, child?.id)"
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            xmlns:xlink="http://www.w3.org/1999/xlink"
                                            width="24px"
                                            height="24px"
                                            viewBox="0 0 24 24"
                                            version="1.1"
                                        >
                                            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                                <rect x="0" y="0" width="24" height="24" />
                                                <rect
                                                    fill="#000000"
                                                    opacity="0.3"
                                                    transform="translate(12.000000, 7.000000) rotate(-180.000000) translate(-12.000000, -7.000000) "
                                                    x="11"
                                                    y="1"
                                                    width="2"
                                                    height="12"
                                                    rx="1"
                                                />
                                                <path
                                                    d="M17,8 C16.4477153,8 16,7.55228475 16,7 C16,6.44771525 16.4477153,6 17,6 L18,6 C20.209139,6 22,7.790861 22,10 L22,18 C22,20.209139 20.209139,22 18,22 L6,22 C3.790861,22 2,20.209139 2,18 L2,9.99305689 C2,7.7839179 3.790861,5.99305689 6,5.99305689 L7.00000482,5.99305689 C7.55228957,5.99305689 8.00000482,6.44077214 8.00000482,6.99305689 C8.00000482,7.54534164 7.55228957,7.99305689 7.00000482,7.99305689 L6,7.99305689 C4.8954305,7.99305689 4,8.88848739 4,9.99305689 L4,18 C4,19.1045695 4.8954305,20 6,20 L18,20 C19.1045695,20 20,19.1045695 20,18 L20,10 C20,8.8954305 19.1045695,8 18,8 L17,8 Z"
                                                    fill="#000000"
                                                    fill-rule="nonzero"
                                                    opacity="0.3"
                                                />
                                                <path
                                                    d="M14.2928932,10.2928932 C14.6834175,9.90236893 15.3165825,9.90236893 15.7071068,10.2928932 C16.0976311,10.6834175 16.0976311,11.3165825 15.7071068,11.7071068 L12.7071068,14.7071068 C12.3165825,15.0976311 11.6834175,15.0976311 11.2928932,14.7071068 L8.29289322,11.7071068 C7.90236893,11.3165825 7.90236893,10.6834175 8.29289322,10.2928932 C8.68341751,9.90236893 9.31658249,9.90236893 9.70710678,10.2928932 L12,12.5857864 L14.2928932,10.2928932 Z"
                                                    fill="#000000"
                                                    fill-rule="nonzero"
                                                />
                                            </g>
                                        </svg>
                                    </a>
                                </ng-container>
                                <ng-container *ngIf="!IsCheckList(subChild)">
                                    <ng-container *ngFor="let lastChild of subChild?.children">
                                        <button
                                            mat-menu-item
                                            (mouseenter)="onHover($event, null, selectionList, taggedItemselectionList)"
                                            (click)="DownloadTemplate(removeSpace(item.name), lastChild)"
                                        >
                                            {{ lastChild.name }}
                                        </button>
                                    </ng-container>
                                </ng-container>
                                <!-- last Menu End-->
                            </mat-menu>
                        </ng-container>
                        <!-- Sub Child Menu End-->
                    </mat-menu>
                </ng-container>
            </ng-container>
            <!-- Sub Menu End-->
        </mat-menu>
    </ng-container>
    <!-- Root Menu End-->
</mat-menu>
